import { render } from "./SearchSelect.vue?vue&type=template&id=29428bbf&bindings={\"items\":\"props\",\"initValue\":\"props\",\"label\":\"props\",\"property\":\"props\",\"classname\":\"props\",\"placeholder\":\"props\",\"filteredItems\":\"options\",\"search\":\"data\",\"activeItem\":\"data\",\"selectItem\":\"options\",\"clearSelection\":\"options\"}"
import script from "./SearchSelect.vue?vue&type=script&lang=js"
export * from "./SearchSelect.vue?vue&type=script&lang=js"
script.render = render

export default script